import React from "react"
import { AuthenticationContext } from "contexts-lib/AuthenticationContext"

/**
 * Higher Order Component (HOC) that wraps a given component and provides it with user state and related functions from the AuthenticationContext.
 * @param {React.Component} WrappedComponent - The component to be wrapped by the HOC.
 * @returns {React.Component} - A new component that renders the original component with user state and related functions passed in as props.
 */
// eslint-disable-next-line react/display-name
export const withUserState = (WrappedComponent) => (props) =>
  (
    <AuthenticationContext.Consumer>
      {({ userState, logOut, isLoggedIn, userDetails }) => (
        <WrappedComponent
          {...props}
          userState={userState}
          logOut={logOut}
          isLoggedIn={isLoggedIn}
          userDetails={userDetails}
        />
      )}
    </AuthenticationContext.Consumer>
  )

/**
 * Higher Order Component (HOC) that wraps a given component with user state and authentication logic.
 * @param {React.Component} WrappedComponent - The component to be wrapped with the authentication logic.
 * @returns {React.Component} - A new component that renders the original component with user state and authentication logic.
 */
export const withAuthentication = (WrappedComponent) => {
  const WrappedComponentWithAuthentication = (props) => (
    <WrappedComponent {...props} />
  )

  return withUserState(WrappedComponentWithAuthentication)
}
